import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipPricingDiscountsCreateView } from './create/create';

export const MembershipPricingDiscountsView = angular
  .module('acme.view.application.membership.pricing.discounts', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    MembershipPricingDiscountsCreateView,
    'acme.view.application.membership.pricing.discounts.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.pricing.discounts',
      url: '/:action/discounts',
      views: {
        'subview-main@application': {
          controller: 'MembershipPricingDiscountsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/pricing/discounts/discounts.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Coupon Discounts',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_VIEW'],
      },
    });
  }).name;
